/* eslint-disable import/prefer-default-export */
export const getElementPosition = (el, selector) => {
  const els = document.querySelectorAll(selector);

  // eslint-disable-next-line space-unary-ops, no-plusplus
  for (let i = 0; i < els.length; i++) {
    if (els[i] === el) {
      // Add 1 to the index position.
      return i + 1;
    }
  }

  return 1;
};
